/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Shape from "App/geometry/objects/shape";
import {RenderElement} from "App/model/elements/element";
import Factory from "App/geometry/objects/factory";
import ModelDescription from "App/model/description";
import ShapeBatchNode from "App/render/webgl/nodes/shape_batch_node";
import OutlineBatch from "App/render/webgl/renderables/batches/outline_batch";
import {OutlineTypeName} from "App/geometry/objects/type_names";
//@ts-ignore
import {EOutlinesStyle} from "js_interface/src/modules/render_settings/scene_render_settings_enums.ts";

export default
class Outline extends Shape {

    public static TypeName: string = OutlineTypeName;

    constructor(aUID: number) {
        super(aUID);

        this._forceHidden = false; // because of turning of outlines (see SceneAPI.RenderSettingsModule.prototype.setShowOutlines)
        this.properties.canCastShadow = false;
    }

    public static create(aUID: number): Outline {
        return new Outline(aUID);
    }


    /**
     * Override the Geometry.prototype.getVisibility because for outlines we need
     * to call getOutlineVisibility function of model element
     */
    public getVisibility(): boolean {
        // the NO_OUTLINES mode is only applied here for not wireframe mode and model loading for the first time when we do not yet have
        // loaded the shapes in gpu so the visibility changes does not take effect during the geometry description parsing
        if (!this.model.getSceneAPI().renderSettingsModule.getWireframeRendering() &&
            this.model.getModelDescription().drawSettings.getDrawStyle().getStyle() == EOutlinesStyle.NO_OUTLINES)
        {
           return false;
        }

        // when user style is user defined, the we check the draw style annotation defined for the model element
        // and we decide the visibility of the outline based on that
        // if (this.model.getModelDescription().drawSettings.userDefined()) {
            // this._renderElementRef.getAnnotation();
        // }

        return super.getVisibility();
    }

    public getPrimitiveSize(): number {
        return 2;
    }

    public parse(aModelDescription: ModelDescription, aShapeJSON: any, aRenderElement: RenderElement) {
        // create appearance.material.diffuseColor from this.properties.color
        aShapeJSON.appearance = aShapeJSON.appearance || {};
        if (!aShapeJSON.appearance.hasOwnProperty("materialRefs")) {
            // back compatibility for models which has the color of outline written in the description tag so we have to
            // create a material in appearance
            aShapeJSON.appearance.material = aShapeJSON.appearance.material || {diffuseColor: aShapeJSON.description.color};
        }

        super.parse(aModelDescription, aShapeJSON, aRenderElement);
    }
}

Factory.register(Outline);
ShapeBatchNode.registerGeometryObject(Outline.TypeName, OutlineBatch);
